/* eslint-disable react/destructuring-assignment */
import { CountrySheetsLayout } from 'features/countrySheets/components/CountrySheetsLayout.component';
import { Content, CountrySheet, CountrySheetsApi as CountrySheetsApiClient } from 'pleinchamp-api-client';
import React, { createContext } from 'react';
import { ApiConfiguration, axiosInstance } from '@api/business/api.conf';
import { usePlcApiCall } from '@api/business/api.hook';
import { fetchServicesNews } from '@services/business/Services.api';
import { isServer } from '@utils/server';
import { defaultNamespaces } from '@utils/strings';
import { PlcNextPage, PlcPageContextProps } from 'features/business/app.types';

interface Props {
  sheets: CountrySheet[];
  news: Content[];
}
const CountrySheetsApi = new CountrySheetsApiClient(ApiConfiguration, undefined, axiosInstance);
function fetchCountrySheets() {
  return CountrySheetsApi.getCountrySheets().then(r => r.data);
}

export const CountrySheetsContext = createContext<PlcPageContextProps<Props>>({
  news: { isValidating: false },
  sheets: { isValidating: false },
});

const CountrySheetsPage: PlcNextPage<Partial<Props>> = props => {
  const sheets = usePlcApiCall(fetchCountrySheets, [], {
    initialData: props.sheets,
  });
  const news = usePlcApiCall(fetchServicesNews, [], {
    initialData: props.news,
  });

  return (
    <CountrySheetsContext.Provider
      value={{
        news,
        sheets,
      }}
    >
      <CountrySheetsLayout />
    </CountrySheetsContext.Provider>
  );
};

CountrySheetsPage.getInitialProps = async () => {
  const pageDefaultState = {
    namespacesRequired: [...defaultNamespaces, 'services'],
    sheets: undefined,
  };
  if (!isServer()) {
    return pageDefaultState;
  }

  return Promise.all([fetchCountrySheets(), fetchServicesNews()])
    .then(([sheets, news]) => ({ ...pageDefaultState, news, sheets }))
    .catch(() => pageDefaultState);
};

export default CountrySheetsPage;
